import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";
import { CheckoutState } from "../../../models";

export const checkoutAdapter: EntityAdapter<CheckoutState> =
  createEntityAdapter<CheckoutState>();
